import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: [ './button.component.scss' ],
})
export class ButtonComponent {
  @Input() text: string;
  @Input() class: any;
  @Input() icon: any;
  @Input() disabled: boolean;
  @Input() reverse = false;
  @Input() disableBorder = false;
  @Input() hoverText: string;
}
